import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRotateIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 44,
	height: 46,
	viewBox: "0 0 44 46",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 26.891,
			cy: 28.3483,
			rx: 3.76599,
			ry: 3.48114,
			fill: "#E0DEF1"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 22,
			cy: 26.0437,
			rx: 17,
			ry: 16.9617,
			fill: "#E9F0FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.75 37.7636H14.25C10.1 37.7636 8.25 35.9178 8.25 31.7771V27.2873C8.25 23.1466 10.1 21.3008 14.25 21.3008H18.75C22.9 21.3008 24.75 23.1466 24.75 27.2873V31.7771C24.75 35.9178 22.9 37.7636 18.75 37.7636ZM14.25 22.7974C10.93 22.7974 9.75 23.9747 9.75 27.2873V31.7771C9.75 35.0897 10.93 36.267 14.25 36.267H18.75C22.07 36.267 23.25 35.0897 23.25 31.7771V27.2873C23.25 23.9747 22.07 22.7974 18.75 22.7974H14.25Z",
			fill: "#2D59AB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29.9985 23.5473C29.5885 23.5473 29.2485 23.208 29.2485 22.799C29.2485 19.8456 27.1885 17.3712 24.4185 16.7227L24.6885 17.1717C24.8985 17.5308 24.7885 17.9898 24.4285 18.1993C24.0685 18.4089 23.6085 18.2991 23.3985 17.9399L22.3485 16.1939C22.2085 15.9644 22.2085 15.675 22.3385 15.4456C22.4785 15.2161 22.7285 15.0664 22.9985 15.0664C27.2685 15.0664 30.7485 18.5386 30.7485 22.799C30.7485 23.208 30.4085 23.5473 29.9985 23.5473Z",
			fill: "#2D59AB"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 40.5318,
			cy: 37.299,
			rx: 2.53176,
			ry: 2.48653,
			fill: "#CCDEFF"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 33.0127,
			cy: 43.7602,
			rx: 1.0127,
			ry: .994611,
			fill: "#CCDEFF"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 29.0127,
			cy: .994611,
			rx: 1.0127,
			ry: .994611,
			fill: "#CCDEFF"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 24.5,
			cy: 7.45918,
			rx: 2.5,
			ry: 2.48653,
			fill: "#E9F0FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19 45.001C28.9 45.001 37 36.9192 37 27.0415C37 17.1638 28.9 9.08203 19 9.08203C9.1 9.08203 1 17.1638 1 27.0415C1 36.9192 9.1 45.001 19 45.001Z",
			stroke: "#2D59AB",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgRotateIcon;
